(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.search = {
    attach: function (context, settings) {
      $(once('search', '.view-search', context)).each(function (index) {
        // check for existing search
        const urlSearchParams = new URLSearchParams(window.location.search);

        // Fetch Butterball Results
        if (urlSearchParams.size) {
          const params = Object.fromEntries(urlSearchParams.entries());
          $('.block-popular-search').hide();

          // create header for BB search results
          const $additionalHeader = $('<div class="view-header view-header--additional"><h3 class="search-keywords">Additional Results from <a href="/farmtofamily">Farm to Family</a> by Butterball</h3></div>');

          // check for filters in the URL
          const filterTypes = ['products', 'recipes', 'others'];
          const filterValue = filterTypes.find(item => location.pathname.includes(item));
          const filterPathFragment = filterValue ? `/${filterValue}` : '';

          // check for empty Farm to Family Results
          let $searchContent = $('.view-search .view-content');
          let $pager = $('.view-search nav.pager');

          // create search content container if it's missing
          const $searchContentWrapper = $('<div class="view-content view-content--additional" />');

          if (!$searchContent.length && !$pager.length) {
            $('.view-search .view-header').after($searchContentWrapper);
            $searchContent = $('.view-search .view-content--additional');
          }
          else if ($searchContent.length && !$pager.length) {
            $searchContent = $('.view-search .view-content');
          }
          else {
            $pager.after($searchContentWrapper);
            $searchContent = $('.view-search .view-content--additional');
          }

          $searchContent.addClass('loading');

          $.ajax(`../farmtofamily/search${filterPathFragment}/rest?search=${params.search}`).done(
            (data)=> {
              $searchContent.removeClass('loading');
              if (!data.length) {
                return;
              }
              $searchContent.append($additionalHeader);

              // Inject Butterball results below F2F results
              if ($searchContent) {
                // eslint-disable-next-line max-nested-callbacks
                data.forEach((item) => {
                  const title = `${item.title}`;
                  const body = item.search_api_excerpt;
                  const searchRow = $(`<div class="views-row"><div class="views-field views-field-title"><span class="field-content">${title}</span></div><div class="views-field views-field-search-api-excerpt"><span class="field-content">${body}</span></div></div>`);

                  $searchContent.append(searchRow);
                });
              }

            }).fail(() => {
            $searchContent.removeClass('loading');
          });
        }
        else {
          $('.block-popular-search').show().css('visibility', 'visible');
        }

        $('.search-view__icon-wrapper').on('click', function () {
          const $searchInput = $('.search-view__search-field-wrapper').find('input');
          const searchInputValue = $searchInput.val();

          if (searchInputValue) {
            $('.views-exposed-form').find('form').submit();
          }
        });
      });
    }
  };
}
)(jQuery, Drupal);
